module.exports.Autodesk = window.Autodesk;
module.exports.THREE = window.THREE;
module.exports.$ = window.$;
module.exports.Snap = window.Snap;